import { render, staticRenderFns } from "./ExpansionPanels.vue?vue&type=template&id=0340e0c0&scoped=true"
import script from "./ExpansionPanels.vue?vue&type=script&lang=ts"
export * from "./ExpansionPanels.vue?vue&type=script&lang=ts"
import style0 from "./ExpansionPanels.vue?vue&type=style&index=0&id=0340e0c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0340e0c0",
  null
  
)

export default component.exports